import '../../../../assets/css/design/support/support.css';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useEffect, useState } from 'react';

export default function PhoneFormat({ value, onChange, disabled }) {
  const [internalValue, setInternalValue] = useState("");
  useEffect(() => {
    if (value) {
      setInternalValue(value);
    }
  }, [value]);

  return (
    <ReactPhoneInput
      country={"id"}
      value={internalValue}
      disabled={disabled}
      onChange={(phone) => {
        setInternalValue(phone);
        if (onChange) {
          onChange(phone);
        }
      }}
    />
  );
}